import { render, staticRenderFns } from "./FarmArbiterZonesView.vue?vue&type=template&id=4773dd27&"
import script from "./FarmArbiterZonesView.vue?vue&type=script&lang=ts&"
export * from "./FarmArbiterZonesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports